var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Retake.42ebf9cc.png","uri@2x": __webpack_public_path__ + "static/media/Retake.2875b4a7.png","uri@3x": __webpack_public_path__ + "static/media/Retake.59331a80.png",
    width: 73,
    height: 22
});